import { render } from "./AnyBank.vue?vue&type=template&id=058b06c7"
import script from "./AnyBank.vue?vue&type=script&lang=js"
export * from "./AnyBank.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__